<template>
  <TopListPanel
    :isFilterEnabled="isFilterEnabled"
    :isFilterSetted="isFilterSetted"
    :items="items"
    searchPlaceholder="Поиск по пользователям"
    buttonLabel="Создать пользователя"
    routeCreate="userCreate"
    @set-common-filter="setCommonFilterParent"
    @toggle-filter="toggleFilterParent"
    :disabled-archive="true"
    :is-button-disabled="isDenied"
  ></TopListPanel>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import { useAuthStore } from "@/store/auth/login";
import TopListPanel from "@/widgets/panels/TopListEntitiesPanel.vue";

defineProps<{
  isFilterEnabled?: boolean;
  isFilterSetted?: boolean;
}>();
const authStore = useAuthStore();
const emit = defineEmits(["setCommonFilter", "toggleFilter"]);

const isDenied = computed(() => {
  return authStore.isDeniedForPermissions(
    ["system:edit"],
    ["users:edit"],
    ["dictionaries:edit"]
  );
});

const setCommonFilterParent = (value: string) => {
  emit("setCommonFilter", value);
};

const toggleFilterParent = () => {
  emit("toggleFilter");
};

const items = ref([
  { label: "Справочники", archive: "both" },
  { label: "Пользователи", archive: "both", reload: true },
]);
</script>
